<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">Comment admin</span>
        </div>
      </div>
      <div class="header-actions">
        <button class="back-btn" v-on:click="goBack">← 一覧へ戻る</button>
        <button class="close-btn" v-on:click="close">閉じる</button>
      </div>
    </header>

    <main class="main-content">
      <div class="white-card">
        <div class="page-head">
          <div>
            <p class="page-kicker">THX post #{{ point_id }}</p>
            <h1 class="page-title">Comment list</h1>
          </div>
          <div class="page-summary">
            <span class="summary-label">Shown</span>
            <span class="summary-value">{{ comments.length }}</span>
          </div>
        </div>

        <div v-if="comments.length > 0" class="comment-list">
          <article v-for="comment in comments" :key="comment.id" class="comment-card">
            <div class="comment-card__head">
              <div class="comment-badges">
                <span class="badge" :class="{ 'badge--reply': comment.reply }">
                  {{ comment.reply ? "Reply" : "Comment" }}
                </span>
                <span class="badge badge--muted">ID {{ comment.id }}</span>
              </div>
              <button class="danger-btn" v-on:click="deleteComment(comment.id)">Delete</button>
            </div>

            <div class="comment-card__meta">
              <span class="comment-author">{{ comment.name }}</span>
              <span v-if="comment.reply" class="comment-reply-note">reply comment</span>
            </div>

            <p class="comment-body">{{ comment.comment }}</p>
          </article>
        </div>

        <div v-else class="empty-state">
          <p class="empty-state__title">No comments yet</p>
          <p class="empty-state__text">New comments will appear here once they are posted.</p>
        </div>

        <div v-if="next_exists" class="more-row">
          <button class="primary-btn primary-btn--wide" v-on:click="more">Load more</button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CommentView",
  data: function() {
    return {
      point_id: 0,
      comments: [],
      page: 1,
      next_exists: true,
    }
  },
  mounted: function() {
    this.point_id = this.$route.params.id;
    this.get();
  },
  methods: {
    get: async function() {
      let data = {
        thx_post_id: this.point_id,
        page: this.page,
        max_id: "",
      };
      await axios.get("/from_comment", {params: data}).then((response) => {
        let this_obj = this;
        if (response.data && response.data.length == 0) {
          this.next_exists = false;
        }
        response.data.forEach(function(x) {
          if (x.is_active === true) {
            x.reply = false;
            this.comments.push(x);
          }
          x.replay_comment.forEach(function(y) {
            if (y.is_active === true) {
              y.reply = true;
              this.comments.push(y);
            }
          }, this_obj);
        }, this_obj);
      });
    },
    deleteComment: async function(comment_id) {
      let data = {
        thx_comment_id: comment_id,
      };
      await axios.get("/delete_comment", {params: data}).then((response) => {
        if (response.data.status == "OK") {
          this.comments = this.comments.filter(function(comment) {
            return comment.id !== comment_id;
          });
        }
      });
    },
    more: function() {
      this.page++;
      this.get();
    },
    close: function() {
      window.close();
    },
    goBack: function() {
      this.$router.push("/thanks");
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(59, 130, 246, 0.12), transparent 28%),
    linear-gradient(180deg, #e7ecf4 0%, #dde2ec 100%);
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 32px;
  min-height: 64px;
  background: #1e2a3a;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.brand-mark {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: linear-gradient(135deg, #4f8ef7, #7c5cfc);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: 800;
  color: #fff;
  flex: 0 0 auto;
}

.brand-info {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  min-width: 0;
}

.brand-name {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
}

.brand-sub {
  font-size: 0.72rem;
  color: #8a9bb0;
}

.header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.back-btn,
.close-btn {
  padding: 8px 16px;
  border-radius: 999px;
  border: 1.5px solid #94a3b8;
  background: transparent;
  color: #d7e0ec;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.back-btn:hover,
.close-btn:hover {
  background: #94a3b8;
  color: #1e2a3a;
  transform: translateY(-1px);
}

.close-btn {
  border-color: #e2e8f0;
}

.main-content {
  max-width: 960px;
  margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  padding: 32px;
}

.page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.page-kicker {
  margin: 0 0 6px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.page-title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1e293b;
}

.page-summary {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #475569;
  white-space: nowrap;
}

.summary-label {
  font-size: 0.82rem;
}

.summary-value {
  min-width: 28px;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
}

.comment-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.comment-card {
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px 20px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.comment-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 10px;
}

.comment-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 999px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 0.75rem;
  font-weight: 700;
}

.badge--reply {
  background: #fee2e2;
  color: #b91c1c;
}

.badge--muted {
  background: #e2e8f0;
  color: #475569;
}

.comment-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
}

.comment-author {
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
}

.comment-reply-note {
  font-size: 0.78rem;
  color: #b45309;
  font-weight: 600;
}

.comment-body {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.8;
  color: #334155;
  white-space: pre-wrap;
}

.danger-btn {
  padding: 8px 14px;
  border-radius: 10px;
  border: none;
  background: #ef4444;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.18s ease, background 0.18s ease;
}

.danger-btn:hover {
  background: #dc2626;
  transform: translateY(-1px);
}

.empty-state {
  padding: 36px 20px;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  background: #f8fafc;
  text-align: center;
}

.empty-state__title {
  margin: 0 0 8px;
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
}

.empty-state__text {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
}

.more-row {
  display: flex;
  justify-content: center;
  margin-top: 22px;
}

.primary-btn {
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  font-family: inherit;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.primary-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(59, 130, 246, 0.25);
}

.primary-btn--wide {
  padding: 12px 24px;
  min-width: 180px;
}

@media (max-width: 640px) {
  .top-header {
    padding: 14px 16px;
    align-items: flex-start;
    flex-direction: column;
  }

  .white-card {
    padding: 20px 16px;
  }

  .page-head {
    flex-direction: column;
  }

  .comment-card__head {
    flex-direction: column;
  }

  .danger-btn {
    width: 100%;
  }
}
</style>
